import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fetchCategories } from "../lib/api";
import { Seo } from "../components/Seo";

export default function Categories() {
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    fetchCategories().then(setCategories).catch(() => {});
  }, []);

  return (
    <div data-testid="categories-page" className="max-w-[1360px] mx-auto px-6 lg:px-10 py-16">
      <Seo title="Peptide Research Categories" description="Browse UK research peptides by category: longevity, healing, metabolic health, growth & recovery, cognitive, performance and more." />
      <div className="max-w-3xl">
        <div className="label-mono">Research Categories</div>
        <h1 className="mt-4 text-4xl lg:text-6xl tracking-tight text-white font-medium">
          Research categories.
        </h1>
        <p className="mt-4 text-[#B7BCC7] max-w-xl">
          Filter the catalog by the biological system or research outcome you are investigating.
        </p>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-px bg-[#2A2A2A] border border-[#2A2A2A] rounded-3xl overflow-hidden">
        {categories.map((c, i) => (
          <Link
            key={c.slug}
            to={`/products?category=${c.slug}`}
            data-testid={`categories-page-${c.slug}`}
            className="p-10 bg-[#0B0B0B] hover:bg-[#111] group transition-colors relative flex items-start justify-between gap-6"
          >
            <div className="max-w-md">
              <div className="label-mono">0{i + 1}</div>
              <div className="mt-4 text-white text-2xl lg:text-3xl tracking-tight font-medium">{c.name}</div>
              <p className="mt-3 text-[#B7BCC7] text-[14px] leading-relaxed">{c.description}</p>
            </div>
            <ArrowUpRight className="text-[#6E7784] group-hover:text-[#1565FF] transition-colors" />
          </Link>
        ))}
      </div>
    </div>
  );
}
